<template>
  <div v-click-outside="closeDropdown">
    <div class="dropdown">
      <div
        class="dropdown-trigger"
        @click="showDropDown = !showDropDown"
      >
        <label>{{ label }} </label>
        <button
          aria-label="toggle dropdown"
          class="button"
        >
          <span>{{ showAlphabet ? $t('common.beginWith'): $t('common.select') }} <strong>{{ modelLabel }}</strong> </span>
          <span
            class="icon-arrow"
            :class="{'up': showDropDown}"
          />
        </button>
      </div>
      <div
        v-show="showDropDown"
        class="dropdown-menu"
        role="menu"
      >
        <template v-if="showAlphabet">
          <div
            class="dropdown-content letters"
            :class="{alphabet: showAlphabet}"
          >
            <template
              v-for="(item, index) in alphabet"
              :key="'dropdown' + index"
            >
              <a
                class="dropdown-item"
                :class="{selected: item === modelValue}"
                aria-label="change value"
                @click="changeValue(item)"
              >
                {{ item }}
              </a>
            </template>
          </div>
        </template>
        <template v-else>
          <!-- only use label for value, for easy display. will get value when send request -->
          <div
            class="dropdown-content"
            :class="{alphabet: showAlphabet}"
          >
            <template
              v-for="(item, index) in options"
              :key="'dropdown' + index"
            >
              <a
                class="dropdown-item"
                :class="{selected: item.value === modelValue}"
                aria-label="Change Value"
                @click="changeValue(item.label)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
/* include alpha beta picker
and standard drop down (single selection)

example:
species table advance filters
*/
import { ref, watch } from 'vue';

// components: {
//   'vue-highcharts': Vue3Highcharts
// },
const props = defineProps(['label', 'modelValue', 'showAlphabet', 'options']);

const emit = defineEmits(['update:modelValue', 'filter:modelValue']);

const showDropDown = ref(false);
const modelLabel = ref(null);
watch(() => props.modelValue, () => {
  modelLabel.value = props.modelValue;
});
// eslint-disable-next-line vue/no-setup-props-destructure
modelLabel.value = props.modelValue;

const createArrayAtoZ = () => {
  // eslint-disable-next-line prefer-spread
  return Array
    .apply(null, { length: 26 })
    .map((x, i) => String.fromCharCode(65 + i));
};
const alphabet = createArrayAtoZ();

const changeValue = (value) => {
  if (value !== props.modelValue) {
    emit('update:modelValue', value); // previously was `this.$emit('input', title)`
    emit('filter:modelValue', value); // previously was `this.$emit('input', title)`
    closeDropdown();
  }
};
const closeDropdown = () => {
  if (showDropDown.value) {
    showDropDown.value = false;
  }
};
</script>
  <style scoped>
  .dropdown .dropdown-menu {
    display: block;
  }
  .dropdown-content.alphabet a {
    display: inline-block;
    padding: 5px;
  }
  .selected {
    color: rgb(228, 104, 21);
  }
  .dropdown-item {
    padding: 10px;
  }
  </style>
